/* ============================================================
   MX MOTORSPORTS – Shop-Ausbau: Verhalten
   Datei: assets/mx-shop.js · geladen am Ende von layout/theme.liquid (defer)
   Einstellungen kommen aus window.MXS (snippets/mx-global.liquid).
   Inhalt:
   1. Mein Fahrzeug (Fahrzeugwahl, gespeichert im Browser): BMW-Baureihe (mx_bmw) oder Marke + Modell (mx_fz)
   2. Passt-Pruefung auf der Produktseite, Leiste "Mehr entdecken", Hinweis auf Kategorien
   3. Videos mit Zwei-Klick-Loesung und Zeitmarken
   4. Sprungnavigation und Kaufleiste (Produktseite, Handy)
   5. Suche: beliebte Suchen, Leistungen und Kategorien auf der Ergebnisseite
   6. Warenkorb: "+ Hinzufuegen"
   7. Newsletter: Klaviyo (nur oeffentlicher Schluessel) und Pop-up
   ============================================================ */
(function () {
  'use strict';
  var M = window.MXS || { fz: [] };
  var KEY = 'mx_bmw';
  var KEY_FZ = 'mx_fz'; /* andere Marken: {"k":"audi","m":"RS6 C8"} – Passt-Pruefung bleibt BMW */

  function store(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
    return null;
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fzBy(tag) { for (var i = 0; i < (M.fz || []).length; i++) if (M.fz[i].t === tag) return M.fz[i]; return null; }
  function mkBy(k) { for (var i = 0; i < (M.mk || []).length; i++) if (M.mk[i].k === k) return M.mk[i]; return null; }

  /* ---------- 1. Mein Fahrzeug ---------- */
  function current() { var t = store(KEY); return t ? fzBy(t) : null; }
  function currentMk() {
    var raw = store(KEY_FZ), o = null;
    if (!raw) return null;
    try { o = JSON.parse(raw); } catch (e) { return null; }
    var b = o && mkBy(o.k);
    if (!b) return null;
    return { k: b.k, n: b.n, m: o.m || '', s: b.s, l: b.l, c: b.c, u: o.u || '' };
  }

  function paint() {
    var f = current(), g = f ? null : currentMk();
    $$('[data-mxs-bmw-code]').forEach(function (el) { el.textContent = f ? f.c : 'wählen'; });
    $$('[data-mxs-fz-code]').forEach(function (el) {
      el.textContent = f ? 'BMW ' + f.c : (g ? g.n + (g.m ? ' ' + g.m : '') : 'wählen');
      var btn = el.closest('[data-mxs-bmw-open]');
      if (btn) btn.classList.toggle('has-fz', !!(f || g));
    });
    $$('[data-mxs-bmw]').forEach(function (el) { el.classList.toggle('is-on', !!f && el.getAttribute('data-mxs-bmw') === f.t); });
    $$('[data-mxs-mod]').forEach(function (el) { el.classList.toggle('is-on', !!g && el.getAttribute('data-mxs-mod') === g.k && el.getAttribute('data-mxs-mod-n') === g.m); });
    paintFit(f); paintVbar(f); paintCollHint(f); paintMega(f);
  }

  /* Marke im Dialog umschalten */
  function showMk(k) {
    var any = false;
    $$('[data-mxs-mkp]').forEach(function (p) { var on = p.getAttribute('data-mxs-mkp') === k; p.hidden = !on; if (on) any = true; });
    if (!any) return;
    $$('[data-mxs-mk]').forEach(function (b) { var on = b.getAttribute('data-mxs-mk') === k; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }

  function openDlg() {
    var d = document.getElementById('mxs-bmw-dlg');
    if (!d) return;
    var g = current() ? null : currentMk();
    showMk(g ? g.k : 'bmw');
    if (typeof d.showModal === 'function') { try { d.showModal(); return; } catch (e) {} }
    d.setAttribute('open', '');
  }
  function closeDlg() {
    var d = document.getElementById('mxs-bmw-dlg');
    if (!d) return;
    if (typeof d.close === 'function') { try { d.close(); return; } catch (e) {} }
    d.removeAttribute('open');
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var opener = t.closest && t.closest('[data-mxs-bmw-open]');
    if (opener) {
      var cur = current(), cmk = cur ? null : currentMk();
      ev.preventDefault();
      if (cur && opener.hasAttribute('data-mxs-bmw-go')) { window.location.href = cur.u; return; }
      if (cmk && opener.hasAttribute('data-mxs-bmw-go')) { window.location.href = cmk.u || cmk.c || cmk.s; return; }
      openDlg(); return;
    }
    var mkb = t.closest && t.closest('[data-mxs-mk]');
    if (mkb) { ev.preventDefault(); showMk(mkb.getAttribute('data-mxs-mk')); return; }
    var mod = t.closest && t.closest('[data-mxs-mod]');
    if (mod) {
      store(KEY, null);
      store(KEY_FZ, JSON.stringify({ k: mod.getAttribute('data-mxs-mod'), m: mod.getAttribute('data-mxs-mod-n') || '', u: mod.getAttribute('href') || '' }));
      paint();
      return; /* Link fuehrt zur Modell- oder Leistungsseite */
    }
    if (t.closest && t.closest('[data-mxs-dlg-close]')) { closeDlg(); return; }
    var dlg = document.getElementById('mxs-bmw-dlg');
    if (dlg && t === dlg) { closeDlg(); return; } /* Klick auf den Hintergrund */
    if (t.closest && t.closest('[data-mxs-bmw-clear]')) { store(KEY, null); store(KEY_FZ, null); paint(); closeDlg(); return; }
    var pick = t.closest && t.closest('[data-mxs-bmw]');
    if (pick) {
      store(KEY_FZ, null);
      store(KEY, pick.getAttribute('data-mxs-bmw'));
      paint();
      /* Auf der Produktseite bleiben: nur pruefen, nicht wegspringen */
      if (pick.closest('#mxs-bmw-dlg') && M.tpl === 'product') { ev.preventDefault(); closeDlg(); }
    }
  });

  /* Hauptmenue: Karte "Dein BMW" im Teile-Feld */
  function paintMega(f) {
    $$('[data-mxm-my]').forEach(function (a) {
      if (!f) { a.hidden = true; return; }
      a.hidden = false;
      a.setAttribute('href', f.u);
      var c = $('[data-mxm-my-c]', a), m = $('[data-mxm-my-m]', a), n = $('[data-mxm-my-n]', a);
      if (c) c.textContent = f.c;
      if (m) m.textContent = f.m;
      if (n) n.textContent = (f.n ? f.n + ' Teile ansehen' : 'Teile ansehen') + ' →';
    });
  }

  /* ---------- 2. Passt-Pruefung, Leiste, Kategorie-Hinweis ---------- */
  function paintFit(f) {
    $$('[data-mxs-fit]').forEach(function (box) {
      var st = $('[data-mxs-fit-st]', box);
      if (!st) return;
      if (!f) { st.style.display = 'none'; st.className = 'mxs-pdp-fit__st'; return; }
      var tags = (box.getAttribute('data-mxs-fit') || '').split(',');
      st.style.display = '';
      if (tags.indexOf(f.t) > -1) {
        st.className = 'mxs-pdp-fit__st is-ok';
        st.textContent = '✓ Für deinen ' + f.c;
      } else {
        st.className = 'mxs-pdp-fit__st is-no';
        st.innerHTML = 'Nicht für ' + esc(f.c) + ' · <a href="' + esc(f.u) + '">passende Teile</a>';
      }
    });
  }

  function paintVbar(f) {
    $$('[data-mxs-vbar]').forEach(function (bar) {
      var code = $('[data-mxs-vbar-code]', bar), mod = $('[data-mxs-vbar-mod]', bar), btn = $('[data-mxs-vbar-btn]', bar);
      if (f) {
        bar.setAttribute('href', f.u);
        if (code) code.textContent = f.c;
        if (mod) mod.textContent = f.m;
        if (btn) btn.textContent = 'Alle ' + f.n + ' Teile für deinen ' + f.c + ' →';
      } else {
        bar.setAttribute('href', '#');
        if (code) code.textContent = 'Noch nicht gewählt';
        if (mod) mod.textContent = 'Wähl deine Baureihe – dann zeigen wir dir nur passende Teile.';
        if (btn) btn.textContent = 'BMW wählen →';
      }
    });
  }

  function paintCollHint(f) {
    var h = $('[data-mxs-fzh]');
    if (!h) return;
    var handle = h.getAttribute('data-mxs-fzh');
    var isVeh = (M.fz || []).some(function (x) { return x.u.split('/').pop() === handle; });
    if (!f || isVeh || h.hasAttribute('data-tagged')) { h.classList.remove('is-on'); return; }
    var a = $('a', h);
    $('b', h).textContent = f.c;
    if (a) a.setAttribute('href', '/collections/' + handle + '/' + f.t);
    h.classList.add('is-on');
  }

  /* ---------- 3. Videos (Zwei-Klick) ---------- */
  function loadVid(fig, start) {
    if (!fig) return;
    var id = fig.getAttribute('data-yt');
    var s = parseInt(start != null ? start : (fig.getAttribute('data-start') || 0), 10) || 0;
    var src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1' + (s ? '&start=' + s : '');
    var ifr = $('iframe', fig);
    if (ifr) { ifr.src = src; return; }
    ifr = document.createElement('iframe');
    ifr.src = src;
    ifr.title = ($('button', fig) && $('button', fig).getAttribute('aria-label')) || 'YouTube-Video';
    ifr.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    ifr.allowFullscreen = true;
    ifr.setAttribute('loading', 'lazy');
    fig.innerHTML = '';
    fig.appendChild(ifr);
    fig.classList.add('is-on');
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var b = t.closest && t.closest('.mxs-vid button');
    if (b) { ev.preventDefault(); loadVid(b.closest('.mxs-vid')); return; }
    var j = t.closest && t.closest('[data-yt-jump],[data-yt-go]');
    if (j) {
      var id = j.getAttribute('data-yt-jump') || j.getAttribute('data-yt-go');
      var fig = document.querySelector('.mxs-vid[data-yt="' + id + '"]');
      if (!fig) return; /* Link oeffnet YouTube */
      ev.preventDefault();
      loadVid(fig, j.getAttribute('data-start'));
      fig.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------- 4. Sprungnavigation und Kaufleiste ---------- */
  function initJump() {
    var nav = $('.mxs-jump');
    if (!nav) return;
    /* unter dem festen Kopf andocken (der Kopf wird beim Scrollen kleiner) */
    var hdr = document.querySelector('sticky-header') || document.querySelector('.section-header');
    var place = function () { if (hdr) nav.style.top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px'; };
    window.addEventListener('scroll', function () { window.requestAnimationFrame(place); }, { passive: true });
    window.addEventListener('resize', place);
    place();
    if (!('IntersectionObserver' in window)) return;
    var links = $$('a[href^="#"]', nav);
    var map = {};
    links.forEach(function (a) { var el = document.getElementById(a.getAttribute('href').slice(1)); if (el) map[el.id] = a; });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting && map[e.target.id]) {
          links.forEach(function (a) { a.classList.remove('is-on'); });
          map[e.target.id].classList.add('is-on');
          var a = map[e.target.id], box = a.parentNode;
          if (box.scrollWidth > box.clientWidth) box.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' });
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  function mainBuy() {
    return document.querySelector('product-info product-form button[name="add"], .product-form button[name="add"]');
  }
  function initSticky() {
    var bar = $('[data-mxs-sticky]');
    if (!bar) return;
    var target = mainBuy() || document.querySelector('.product__info-container');
    if (!target) return;
    var foot = document.querySelector('.footer') || document.querySelector('footer');
    var upd = function () {
      var past = target.getBoundingClientRect().bottom < 0; /* Kaufen-Knopf nach oben aus dem Bild */
      var atFoot = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-on', past && !atFoot);
    };
    window.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
    var b = $('[data-mxs-sticky-buy]', bar);
    if (b) b.addEventListener('click', function () {
      var mb = mainBuy();
      if (mb && !mb.disabled) { mb.click(); }
      else if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  /* ---------- 5. Suche ---------- */
  function popularTerms() { return String(M.popular || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); }
  function chipsHtml(terms) {
    return terms.map(function (t) { return '<a href="/search?q=' + encodeURIComponent(t) + '&options%5Bprefix%5D=last">' + esc(t) + '</a>'; }).join('');
  }
  function initPopular() {
    var terms = popularTerms();
    if (!terms.length) return;
    $$('predictive-search').forEach(function (ps) {
      var form = $('form', ps), input = $('input[type="search"]', ps);
      if (!form || !input || $('.mxs-popular', ps)) return;
      var box = document.createElement('div');
      box.className = 'mxs mxs-popular';
      box.innerHTML = '<div class="mxs-popular__l">Beliebte Suchen</div><div class="mxs-chips">' + chipsHtml(terms) + '</div>';
      form.appendChild(box);
      function upd() { box.classList.toggle('is-on', document.activeElement === input && !input.value.trim()); }
      input.addEventListener('focus', upd);
      input.addEventListener('input', upd);
      input.addEventListener('blur', function () { setTimeout(upd, 200); });
    });
  }
  /* Öl-Ratgeber: feste Zeile in der Vorschau-Suche, wenn der Suchbegriff zu Öl passt (gleiche Regel wie sections/main-search.liquid) */
  function isOil(q) {
    return String(q || '').toLowerCase().split(/[\s\-\/,.]+/).some(function (t) {
      return !!t && (/^(öl|oel|0w|5w|10w|15w|20w)/.test(t) || /(öl|oel)$/.test(t) || /motul|dctf/.test(t));
    });
  }
  function initOilHint() {
    $$('predictive-search').forEach(function (ps) {
      var input = $('input[type="search"]', ps), box = $('[data-predictive-search]', ps);
      if (!input || !box || ps.getAttribute('data-mxs-oil')) return;
      ps.setAttribute('data-mxs-oil', '1');
      function apply() {
        var cur = $('.mxs-oilps', box), want = isOil(input.value);
        if (!want) { if (cur) cur.parentNode.removeChild(cur); return; }
        var res = $('#predictive-search-results', box);
        if (!res || cur) return;
        var a = document.createElement('a');
        a.className = 'mxs mxs-oilps';
        a.href = '/pages/bmw-motoroel';
        a.textContent = 'Öl-Ratgeber für BMW: welches Öl in welchen Motor →';
        res.insertBefore(a, res.firstChild);
      }
      if (window.MutationObserver) new MutationObserver(apply).observe(box, { childList: true });
      input.addEventListener('input', function () { setTimeout(apply, 0); });
    });
  }
  function initSearchExtras() {
    var box = $('[data-mxs-sx]');
    if (!box) return;
    var q = box.getAttribute('data-q');
    if (!q) return;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=page,collection&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.resources || !j.resources.results) return;
      var res = j.resources.results, html = '';
      var pages = (res.pages || []).filter(function (p) { return !/anfrage|kontakt|impressum|datenschutz|agb|widerruf/i.test(p.handle || p.url || ''); });
      if (pages.length) html += '<div class="mxs-sx__row"><span class="mxs-sx__lab">Leistungen</span>' + pages.map(function (p) { return '<a class="is-page" href="' + esc(p.url) + '">' + esc(p.title) + ' →</a>'; }).join('') + '</div>';
      var cols = res.collections || [];
      if (cols.length) html += '<div class="mxs-sx__row"><span class="mxs-sx__lab">Kategorien</span>' + cols.map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      if (html) {
        box.innerHTML = html; box.hidden = false;
        var head = document.querySelector('.template-search__header');
        if (head && head.parentNode) head.parentNode.insertBefore(box.parentNode.removeChild(box), head.nextSibling);
        box.classList.add('page-width', 'mxs');
      }
    }).catch(function () {});
  }

  /* ---------- 6. Warenkorb: + Hinzufuegen (nur noch Rückfall – normal übernimmt assets/mx-upsell.js mit Messung) ---------- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-mxs-add]');
    if (!b || window.MXUpsell) return;
    ev.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    var old = b.textContent;
    b.textContent = '…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(b.getAttribute('data-mxs-add'), 10), quantity: 1 }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.status) { b.textContent = 'Nicht verfügbar'; return; }
      if (drawer && j.sections && typeof drawer.renderContents === 'function') {
        j.id = body.items[0].id;
        drawer.renderContents(j);
      } else { window.location.reload(); }
    }).catch(function () { b.disabled = false; b.textContent = old; });
  });

  /* ---------- 7. Newsletter und Pop-up ---------- */
  var NL_DONE = 'mx_nl_done', NL_SNOOZE = 'mx_nl_snooze';
  function klaviyo(mail, quelle, liste) {
    var k = M.kl && M.kl.k, l = liste;
    if (!k || !l) return null;
    var body = { data: { type: 'subscription', attributes: { custom_source: quelle, profile: { data: { type: 'profile', attributes: {
      email: mail,
      properties: { Quelle: quelle, Einwilligung_Zeitpunkt: new Date().toISOString(), Einwilligung_Quelle: window.location.href },
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    } } } }, relationships: { list: { data: { type: 'list', id: l } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-07-15' }, body: JSON.stringify(body), mode: 'cors' /* ohne keepalive: mit Vorabanfrage (revision-Header) bricht Chrome sonst ab */
    });
  }
  function hookForm(form, quelle, liste, okText) {
    if (!form) return;
    quelle = form.getAttribute('data-mxs-quelle') || quelle;
    form.addEventListener('submit', function (ev) {
      var inp = $('input[type="email"]', form);
      var mail = inp && inp.value.trim();
      var req = mail ? klaviyo(mail, quelle, liste) : null;
      if (!req) { store(NL_DONE, '1'); return; } /* ohne Klaviyo: normale Shopify-Anmeldung */
      ev.preventDefault();
      var btn = $('button[type="submit"]', form); if (btn) btn.disabled = true;
      req.then(function (r) {
        if (r.ok || r.status === 202) {
          store(NL_DONE, '1');
          form.innerHTML = '<p class="mxs-nl__ok" role="status">' + esc(okText) + '</p>';
        } else { if (btn) btn.disabled = false; form.insertAdjacentHTML('beforeend', '<p class="mxs-nl__ok" role="alert">Das hat nicht geklappt – bitte versuch es noch einmal.</p>'); }
      }).catch(function () { if (btn) btn.disabled = false; });
    });
  }
  function initNewsletter() {
    /* Pop-up -> eigene Liste (Auswertung), Newsletter-Bereiche -> Liste "Newsletter-Bereiche" (sonst Pop-up-Liste) */
    var kl = M.kl || {}, ok = 'Fast geschafft – bitte bestätige deinen VIP-Zugang in der E-Mail, die wir dir gerade geschickt haben.';
    hookForm(document.getElementById('mxs-nl-form'), 'Startseite', kl.n || kl.l, ok);
    hookForm(document.getElementById('mxs-pop-form'), 'Pop-up', kl.l, ok);
    hookForm(document.getElementById('mxs-ft-form'), 'Fußzeile', kl.n || kl.l, ok);
    /* Erfolgreiche Shopify-Anmeldung (Seite kommt mit ?customer_posted=true zurueck) */
    if (/customer_posted=true/.test(window.location.search)) store(NL_DONE, '1');
  }

  function initPopup() {
    var pop = document.getElementById('mxs-pop'), teaser = document.getElementById('mxs-teaser');
    /* Vorschau ohne Einschalten: ?mx_popup=vorschau zeigt das Pop-up sofort (keine Sperren, keine Ruhezeit) */
    if (pop && /[?&]mx_popup=vorschau/.test(window.location.search)) {
      pop.classList.add('is-on');
      pop.addEventListener('click', function (ev) { if (ev.target === pop || (ev.target.closest && ev.target.closest('[data-mxs-pop-close]'))) pop.classList.remove('is-on'); });
      return;
    }
    if (!M.pop || !pop) return;
    var path = window.location.pathname;
    if (/^\/(cart|checkout|checkouts|account|pages\/anfrage|pages\/widerruf)/.test(path) || M.tpl === 'cart') return;
    /* Ruhezeiten (localStorage ueber store(), mit try/catch): einmal gezeigt -> 1 Tag, geschlossen -> 14 Tage, angemeldet -> nie wieder (NL_DONE) */
    function blocked() {
      if (store(NL_DONE)) return true;
      var s = parseInt(store(NL_SNOOZE) || '0', 10);
      return !!(s && Date.now() < s);
    }
    if (M.sub || store(NL_DONE)) return;
    if (/[?&](utm_source=klaviyo|_kx=)/i.test(window.location.search)) { store(NL_DONE, '1'); return; }
    if (blocked()) return;
    var shown = false, teaserShown = false;
    function snoozeFor(days) {
      var cur = parseInt(store(NL_SNOOZE) || '0', 10), until = Date.now() + days * 864e5;
      if (!(cur > until)) store(NL_SNOOZE, String(until));
    }
    function snoozeIt() { store(NL_SNOOZE, String(Date.now() + 14 * 864e5)); }
    function markShown() { snoozeFor(1); }
    /* auto = von selbst (Zeit, Scrollen, Verlassen): nicht, wenn inzwischen auf einer anderen Seite gezeigt/geschlossen/angemeldet */
    function open(auto) {
      if (shown) return;
      if (auto === true && blocked()) return;
      shown = true;
      markShown();
      pop.classList.add('is-on');
      if (teaser) teaser.classList.remove('is-on');
      var i = $('input[type="email"]', pop); if (i) setTimeout(function () { i.focus(); }, 50);
    }
    function close() { pop.classList.remove('is-on'); snoozeIt(); }
    pop.addEventListener('click', function (ev) { if (ev.target === pop || (ev.target.closest && ev.target.closest('[data-mxs-pop-close]'))) close(); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && pop.classList.contains('is-on')) close(); });
    /* Zurueck-Taste (Seite aus dem Browser-Cache): ein offenes Pop-up bzw. die Leiste nicht erneut zeigen */
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      pop.classList.remove('is-on');
      if (teaser) teaser.classList.remove('is-on');
    });
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    if (mobile) {
      if (!teaser) return;
      /* Leiste nur zeigen (und erst dann merken), wenn keine Kaufleiste der Produktseite sichtbar ist */
      var showTeaser = function () {
        if (shown || teaserShown || blocked()) return;
        if (document.querySelector('.mxs-sticky.is-on')) return;
        teaserShown = true;
        markShown();
        teaser.classList.add('is-on');
      };
      setTimeout(function tryT() { showTeaser(); if (!teaserShown && !shown && !blocked()) setTimeout(tryT, 3000); }, 20000);
      window.addEventListener('scroll', function onS() {
        var h = document.documentElement;
        if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.5) { showTeaser(); if (teaserShown || shown) window.removeEventListener('scroll', onS); }
      }, { passive: true });
      teaser.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-mxs-teaser-x]')) { teaser.classList.remove('is-on'); snoozeIt(); return; }
        if (ev.target.closest('[data-mxs-pop-open]')) open(false);
      });
    } else {
      setTimeout(function () { open(true); }, 20000);
      window.addEventListener('scroll', function onS() {
        var h = document.documentElement;
        if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.5) { open(true); window.removeEventListener('scroll', onS); }
      }, { passive: true });
      document.addEventListener('mouseout', function (ev) { if (!ev.relatedTarget && ev.clientY <= 0) open(true); });
    }
  }

  /* Fusszeile: "Cookie-Einstellungen" nur zeigen, wenn Shopifys Cookie-Banner seine Einstellungen anbietet */
  function initCookieLink() {
    var b = $('[data-mxf-cookie]');
    if (!b) return;
    var tries = 0;
    (function chk() {
      var pb = window.privacyBanner;
      if (pb && typeof pb.showPreferences === 'function') {
        b.hidden = false;
        b.addEventListener('click', function () { try { window.privacyBanner.showPreferences(); } catch (e) {} });
      } else if (tries++ < 20) { setTimeout(chk, 500); }
    })();
  }

  /* ---------- Start ---------- */
  function init() {
    paint();
    initJump();
    initSticky();
    initPopular();
    initOilHint();
    initSearchExtras();
    initNewsletter();
    initPopup();
    initCookieLink();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* ---------- 8. Hauptmenue (Desktop): Hover mit Verzoegerung, Pfeil-Knopf, Tastatur, Touch ---------- */
  (function () {
    var nav = $('[data-mxm]');
    if (!nav) return;
    var items = $$('.mxm__item--panel', nav);
    var openIt = null, tOpen = 0, tClose = 0, lastPtr = 'mouse';
    var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    function setOpen(it, on) {
      it.classList.toggle('is-open', on);
      var b = $('.mxm__tog', it);
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function open(it) {
      clearTimeout(tClose);
      if (openIt && openIt !== it) setOpen(openIt, false);
      setOpen(it, true); openIt = it;
      document.documentElement.classList.add('mxm-open');
    }
    function close(it) {
      if (!it) return;
      setOpen(it, false);
      if (openIt === it) { openIt = null; document.documentElement.classList.remove('mxm-open'); }
    }
    items.forEach(function (it) {
      var top = $('.mxm__top', it), tog = $('.mxm__tog', it);
      it.addEventListener('mouseenter', function () {
        if (!canHover) return;
        clearTimeout(tClose); clearTimeout(tOpen);
        tOpen = setTimeout(function () { open(it); }, openIt ? 0 : 110);
      });
      it.addEventListener('mouseleave', function () {
        if (!canHover) return;
        clearTimeout(tOpen);
        tClose = setTimeout(function () { close(it); }, 220);
      });
      if (tog) tog.addEventListener('click', function (e) { e.preventDefault(); if (it.classList.contains('is-open')) close(it); else open(it); });
      if (top) top.addEventListener('click', function (e) {
        if (lastPtr !== 'mouse' && !it.classList.contains('is-open')) { e.preventDefault(); open(it); }
      });
      it.addEventListener('focusout', function (e) { if (e.relatedTarget && !it.contains(e.relatedTarget)) close(it); });
    });
    document.addEventListener('pointerdown', function (e) {
      lastPtr = e.pointerType || 'mouse';
      if (openIt && !openIt.contains(e.target)) close(openIt);
    }, true);
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && openIt) { var b = $('.mxm__tog', openIt); close(openIt); if (b) b.focus(); }
    });
  })();
})();
